export default {
  title: 'Add-on per un maggiore successo',
  description: 'Potenzia il tuo piano con funzionalità aggiuntive',
  buttons: {
    continue: 'Continua',
    no_app_for_now: 'Nessuna app mobile per ora',
  },
  toasts: {
    something_went_wrong: 'Si è verificato un errore, prova ad aggiornare la pagina o contatta il supporto tecnico!',
    failed_to_save_changes: 'Impossibile salvare le modifiche, contatta il supporto tecnico!',
    changes_got_saved: 'Modifiche salvate con successo!',
  },
};
